module.exports = __webpack_public_path__ + "img/icons_Prancheta 1-33.ab0a1d5a.svg";